/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-bootstrap/modal/modal-backdrop.component';
const styles_ModalBackdropComponent:any[] = ([] as any[]);
export const RenderType_ModalBackdropComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ModalBackdropComponent,data:{}});
export function View_ModalBackdropComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_ModalBackdropComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'bs-modal-backdrop',
      [['class','modal-backdrop']],(null as any),(null as any),(null as any),View_ModalBackdropComponent_0,
      RenderType_ModalBackdropComponent)),i0.ɵdid(49152,(null as any),0,i1.ModalBackdropComponent,
      [i0.ElementRef,i0.Renderer],(null as any),(null as any))],(null as any),(null as any));
}
export const ModalBackdropComponentNgFactory:i0.ComponentFactory<i1.ModalBackdropComponent> = i0.ɵccf('bs-modal-backdrop',
    i1.ModalBackdropComponent,View_ModalBackdropComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiZDovYS8xL3MvU29mdHdhcmVNYW5hZ2VyL25vZGVfbW9kdWxlcy9uZzItYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAvbW9kYWwvbW9kYWwtYmFja2Ryb3AuY29tcG9uZW50LmQudHMiLCJuZzovLy9kOi9hLzEvcy9Tb2Z0d2FyZU1hbmFnZXIvbm9kZV9tb2R1bGVzL25nMi1ib290c3RyYXAvbW9kYWwvbW9kYWwtYmFja2Ryb3AuY29tcG9uZW50LmQudHMuTW9kYWxCYWNrZHJvcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxicy1tb2RhbC1iYWNrZHJvcD48L2JzLW1vZGFsLWJhY2tkcm9wPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7dUNBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./Client/$$_gendir/~/ng2-bootstrap/modal/modal-backdrop.component.ngfactory.ts